import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../redux/axios";

const initialState = {
  scheduleEditData: [], 
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",

  deleteSchedule: {},
  isSuccessDeleteSchedule: false,
  isErrorDeleteSchedule: false,
  isErrorMessageDeleteSchedule: "",

  editSchedule: {},
  isFetchingEdit: false,
  isSuccessEditSchedule: false,
  isErrorEditSchedule: false,
  isErrorMessageEditSchedule: "",

  isFetchingUpdate: false,
  updateSchedule: {},
  isSuccessUpdateSchedule: false,
  isErrorUpdateSchedule: false,
  isErrorMessageUpdateSchedule: "",
};

export const getScheduleData = createAsyncThunk(
  "schedule/get-all-schedule", 
  async (params = {}, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const {
        pageNumber = 0,
        pageSize = 10,
        sortBy = "createdOn",
        sortDirection = "desc",
        searchTerm,
        startDate,
        endDate,
        clientId,
        toGmt,
      } = params;
      const query = new URLSearchParams({
        page: String(pageNumber),
        size: String(pageSize),
        sortBy,
        sortDirection,
      });

      if (searchTerm) query.set("search", searchTerm);
      if (startDate) query.set("startDate", startDate);
      if (endDate) query.set("endDate", endDate);
      if (clientId) query.set("clientId", clientId);
      if (toGmt) query.set("toGmt", toGmt);

      const url = `/sms/listSchedule?${query.toString()}`;

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const deleteScheduleData = createAsyncThunk(
  "schedule/delete-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const response = await axios.delete(
        `/sms/abort/schedule?scheduleId=${udata.id}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      let data = response;
      if (response.status === 200) {
        return data.data;
      } else if (response.status === 201) {
        return data.data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getEditScheduleData = createAsyncThunk(
  "schedule/edit-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        `sms/edit/schedule?scheduleId=${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const updateScheduleData = createAsyncThunk(
  "schedule/update-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post(
        `sms/modify`,
        
        udata.formData,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const sendScheduleData = createAsyncThunk(
  "schedule/update-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post(
        `sms/send-now`,
        udata.formData,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const scheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    clearStateSchedule: (state, { payload }) => {
      state.scheduleEditData = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
    },
    clearStateDeleteSchedule: (state, { payload }) => {
      state.deleteSchedule = {};
      state.isFetching = false;
      state.isSuccessDeleteSchedule = false;
      state.isErrorDeleteSchedule = false;
      state.isErrorMessageDeleteSchedule = "";
    },
    clearStateEditSchedule: (state, { payload }) => {
      state.editSchedule = {};
      state.isFetching = false;
      state.isSuccessEditSchedule = false;
      state.isErrorEditSchedule = false;
      state.isErrorMessageEditSchedule = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduleData.fulfilled, (state, action) => {
        const apiResponse = action.payload?.data;
        let rows = [];

        // API may return a plain array (legacy) or a paginated object
        // e.g. { data: [...], pageNumber, pageSize, totalElements, ... }
        if (Array.isArray(apiResponse)) {
          rows = apiResponse;
        } else if (apiResponse && Array.isArray(apiResponse.data)) {
          rows = apiResponse.data;
        } else if (apiResponse && Array.isArray(apiResponse.content)) {
          rows = apiResponse.content;
        } else if (Array.isArray(action.payload)) {
          rows = action.payload;
        }

        state.scheduleEditData = rows;
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getScheduleData.rejected, (state, action) => {
        state.scheduleEditData = [];
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      
      .addCase(getEditScheduleData.fulfilled, (state, action) => {
        state.editSchedule = action.payload;
        state.isFetchingEdit = false;
        state.isSuccess = true;
      })
      .addCase(getEditScheduleData.pending, (state) => {
        state.isFetchingEdit = true;
      })
      .addCase(getEditScheduleData.rejected, (state, action) => {
        state.editSchedule = {};
        state.isFetchingEdit = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      
      .addCase(deleteScheduleData.fulfilled, (state, action) => {
        state.deleteSchedule = action.payload;
        state.isFetching = false;
        state.isSuccessDeleteSchedule = true;

        if (Array.isArray(state.scheduleEditData) && state.scheduleEditData.length === 1) {
          state.scheduleEditData = [];
        }
      })
      .addCase(deleteScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteScheduleData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorDeleteSchedule = true;
        state.isErrorMessageDeleteSchedule = action.payload
          ? action.payload.message
          : "Internal error";
      })
      
      .addCase(updateScheduleData.fulfilled, (state, action) => {
        state.updateSchedule = action.payload;
        state.isFetchingUpdate = false;
        state.isSuccessUpdateSchedule = true;
        state.isErrorMessageUpdateSchedule = action.payload.data;
      })
      .addCase(updateScheduleData.pending, (state) => {
        state.isFetchingUpdate = true;
      })
      .addCase(updateScheduleData.rejected, (state, action) => {
        state.isFetchingUpdate = false;
        state.isErrorUpdateSchedule = true;
        state.isErrorMessageUpdateSchedule = action.payload
          ? action.payload.message
          : "Internal error";
      });
  },
});

export const {
  clearStateSchedule,
  clearStateDeleteSchedule,
  clearStateEditSchedule,
} = scheduleSlice.actions;

export function clearState() {
  return async (dispatch) => {
    dispatch(clearStateSchedule());
  };
}

export function clearStateDelete() {
  return async (dispatch) => {
    dispatch(clearStateDeleteSchedule());
  };
}

export function clearStateEdit() {
  return async (dispatch) => {
    dispatch(clearStateEditSchedule());
  };
}

export const scheduleEditSelector = (state) => state.scheduleEdit;

export default scheduleSlice.reducer;
